/**
 * Returns tableViewId concatenated by itemId
 * @param itemId
 * @param tableViewId
 */
export default function getTableToItemRelationKey(itemId: string, tableViewId: string): string {
    return tableViewId + itemId;
}
